import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { gatewayApi, type GatewayRouteSpec } from "../api/gateway";

const keys = {
  all: ["gateway-routes"] as const,
  list: () => [...keys.all, "list"] as const,
  preview: (spec: GatewayRouteSpec) => [...keys.all, "preview", spec] as const,
};

export function useGatewayRoutes() {
  return useQuery({
    queryKey: keys.list(),
    queryFn: () => gatewayApi.list(),
    refetchInterval: 30_000,
  });
}

export function useGatewayRoutePreview(spec: GatewayRouteSpec | null) {
  return useQuery({
    queryKey: keys.preview(spec as GatewayRouteSpec),
    queryFn: () => gatewayApi.preview(spec as GatewayRouteSpec),
    enabled: !!spec,
    staleTime: 5_000,
  });
}

export function useCreateGatewayRoute() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (spec: GatewayRouteSpec) => gatewayApi.create(spec),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useUpdateGatewayRoute() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (spec: GatewayRouteSpec) => gatewayApi.update(spec),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteGatewayRoute() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (spec: GatewayRouteSpec) => gatewayApi.remove(spec),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.all }),
  });
}
